import { Link } from 'react-router-dom';
import { Image, LI, P, UL } from '../../../AbstractElements';
import { profileHeaderData } from '../../../Data/HeaderData/RightHeaderData';
import { dynamicImage } from '../../../Utils';
import FeatherIconCom from '../../../Utils/CommonComponents/CommonIcons/FeatherIconCom';
import { Admin, HelenWalter, Logout } from '../../../Utils/Constants';

export default function ProfileHeader() {
    const logout = () => {
        localStorage.clear();
    }
    return (
        <LI className="profile-nav onhover-dropdown p-0">
            <div className="d-flex align-items-center profile-media">
                <Image className="b-r-10 img-40" src={dynamicImage(`dashboard/profile.png`)} alt="" />
                <div className="flex-grow-1"><span>{HelenWalter}</span>
                    <P className="mb-0">{Admin} <i className="middle fa fa-angle-down" /></P>
                </div>
            </div>
            <UL className="profile-dropdown onhover-show-div simple-list">
                {profileHeaderData.map((data) => (
                    <LI key={data.id}>
                        <Link to={`${process.env.PUBLIC_URL}/${data.url}`}>
                            <FeatherIconCom iconName={data.icon} />
                            <span>{data.text}</span>
                        </Link>
                    </LI>
                ))}
                <LI>
                    <Link onClick={logout} to={`${process.env.PUBLIC_URL}/login`}>
                        <FeatherIconCom iconName={"LogIn"} />
                        <span>{Logout}</span>
                    </Link>
                </LI>
            </UL>
        </LI>
    )
}